module.exports = __webpack_public_path__ + "img/22_65.fc9ae4a7.png";